export type DocsNavItem = {
  title: string;
  /** URL path under /docs, e.g. "" for intro or "spolecne/01-prihlaseni-a-registrace" */
  path: string;
  /** File under /user-docs/, e.g. "00-uvod.md" */
  file: string;
};

export type DocsNavSection = {
  id: string;
  title: string;
  items: DocsNavItem[];
};

export const DOCS_INTRO: DocsNavItem = {
  title: 'Úvod',
  path: '',
  file: '00-uvod.md',
};

export const DOCS_SECTIONS: DocsNavSection[] = [
  {
    id: 'spolecne',
    title: 'Společné pro všechny',
    items: [
      { title: 'Přihlášení a registrace', path: 'spolecne/01-prihlaseni-a-registrace', file: 'spolecne/01-prihlaseni-a-registrace.md' },
      { title: 'Připojení přes pozvánku', path: 'spolecne/02-pripojeni-pres-pozvanku', file: 'spolecne/02-pripojeni-pres-pozvanku.md' },
      { title: 'Základní ovládání', path: 'spolecne/03-zakladni-ovladani', file: 'spolecne/03-zakladni-ovladani.md' },
      { title: 'Zprávy a chat', path: 'spolecne/04-zpravy-a-chat', file: 'spolecne/04-zpravy-a-chat.md' },
      { title: 'Oznámení a notifikace', path: 'spolecne/05-oznameni-a-notifikace', file: 'spolecne/05-oznameni-a-notifikace.md' },
      { title: 'Můj profil a nastavení', path: 'spolecne/06-muj-profil-a-nastaveni', file: 'spolecne/06-muj-profil-a-nastaveni.md' },
      { title: 'Synchronizace kalendáře', path: 'spolecne/07-synchronizace-kalendare', file: 'spolecne/07-synchronizace-kalendare.md' },
      { title: 'Prohlídka aplikace', path: 'spolecne/08-prohlidka-aplikace', file: 'spolecne/08-prohlidka-aplikace.md' },
      { title: 'Dostupnost', path: 'spolecne/09-dostupnost', file: 'spolecne/09-dostupnost.md' },
      { title: 'Demo účet Firma Ompli', path: 'spolecne/10-demo-ucet', file: 'spolecne/10-demo-ucet.md' },
      { title: 'Přístup pro AI asistenty', path: 'spolecne/11-pristup-pro-ai-asistenty', file: 'spolecne/11-pristup-pro-ai-asistenty.md' },
    ],
  },
  {
    id: 'vlastnik-manazer',
    title: 'Pro majitele a manažery',
    items: [
      { title: 'Přehled (Dashboard)', path: 'vlastnik-manazer/01-prehled-dashboard', file: 'vlastnik-manazer/01-prehled-dashboard.md' },
      { title: 'Reporty', path: 'vlastnik-manazer/02-reporty', file: 'vlastnik-manazer/02-reporty.md' },
      { title: 'Pobočky', path: 'vlastnik-manazer/03-pobocky', file: 'vlastnik-manazer/03-pobocky.md' },
      { title: 'Pozice', path: 'vlastnik-manazer/04-pozice', file: 'vlastnik-manazer/04-pozice.md' },
      { title: 'Uživatelské skupiny', path: 'vlastnik-manazer/20-uzivatelske-skupiny', file: 'vlastnik-manazer/20-uzivatelske-skupiny.md' },
      { title: 'Zaměstnanci', path: 'vlastnik-manazer/05-zamestnanci', file: 'vlastnik-manazer/05-zamestnanci.md' },
      { title: 'Manažeři', path: 'vlastnik-manazer/06-manazeri', file: 'vlastnik-manazer/06-manazeri.md' },
      { title: 'Správa směn', path: 'vlastnik-manazer/07-sprava-smen', file: 'vlastnik-manazer/07-sprava-smen.md' },
      { title: 'Schvalování docházky', path: 'vlastnik-manazer/08-schvalovani-dochazky', file: 'vlastnik-manazer/08-schvalovani-dochazky.md' },
      { title: 'Schvalování odhlášení ze směny', path: 'vlastnik-manazer/09-schvalovani-dovolenych', file: 'vlastnik-manazer/09-schvalovani-dovolenych.md' },
      { title: 'Schvalování výměn směn', path: 'vlastnik-manazer/10-schvalovani-vymen-smen', file: 'vlastnik-manazer/10-schvalovani-vymen-smen.md' },
      { title: 'Smlouvy', path: 'vlastnik-manazer/11-smlouvy', file: 'vlastnik-manazer/11-smlouvy.md' },
      { title: 'Nastavení firmy', path: 'vlastnik-manazer/12-nastaveni-firmy', file: 'vlastnik-manazer/12-nastaveni-firmy.md' },
      { title: 'Fakturace a kredity', path: 'vlastnik-manazer/13-fakturace-a-kredity', file: 'vlastnik-manazer/13-fakturace-a-kredity.md' },
      { title: 'Nabídky práce', path: 'vlastnik-manazer/14-nabor-nabidky-prace', file: 'vlastnik-manazer/14-nabor-nabidky-prace.md' },
      { title: 'Uchazeči o práci', path: 'vlastnik-manazer/15-nabor-uchazeci', file: 'vlastnik-manazer/15-nabor-uchazeci.md' },
      { title: 'Odesílání oznámení', path: 'vlastnik-manazer/16-odesilani-oznameni', file: 'vlastnik-manazer/16-odesilani-oznameni.md' },
      { title: 'Nedávná aktivita', path: 'vlastnik-manazer/17-nedavna-aktivita', file: 'vlastnik-manazer/17-nedavna-aktivita.md' },
      { title: 'Zákonná dovolená a odpočinek (CZ)', path: 'vlastnik-manazer/18-zakonna-dovolena', file: 'vlastnik-manazer/18-zakonna-dovolena.md' },
      { title: 'Veřejné API', path: 'vlastnik-manazer/19-verejne-api', file: 'vlastnik-manazer/19-verejne-api.md' },
    ],
  },
  {
    id: 'zamestnanec',
    title: 'Pro zaměstnance',
    items: [
      { title: 'Moje směny', path: 'zamestnanec/01-moje-smeny', file: 'zamestnanec/01-moje-smeny.md' },
      { title: 'Docházka a timesheet', path: 'zamestnanec/02-dochazka-a-timesheet', file: 'zamestnanec/02-dochazka-a-timesheet.md' },
      { title: 'Odhlášení ze směny', path: 'zamestnanec/03-zadost-o-dovolenou', file: 'zamestnanec/03-zadost-o-dovolenou.md' },
      { title: 'Výměna směn', path: 'zamestnanec/04-vymena-smen', file: 'zamestnanec/04-vymena-smen.md' },
      { title: 'Moje práce a pozvánky', path: 'zamestnanec/05-moje-prace-a-pozvanky', file: 'zamestnanec/05-moje-prace-a-pozvanky.md' },
      { title: 'Moje smlouvy', path: 'zamestnanec/06-moje-smlouvy', file: 'zamestnanec/06-moje-smlouvy.md' },
      { title: 'Hledání práce', path: 'zamestnanec/07-hledani-prace', file: 'zamestnanec/07-hledani-prace.md' },
      { title: 'Můj životopis', path: 'zamestnanec/08-moje-zivotopis', file: 'zamestnanec/08-moje-zivotopis.md' },
      { title: 'Zákonná dovolená (CZ)', path: 'zamestnanec/09-zakonna-dovolena', file: 'zamestnanec/09-zakonna-dovolena.md' },
    ],
  },
];

/** Flat ordered list for prev/next and path lookup. */
export const DOCS_FLAT: DocsNavItem[] = [
  DOCS_INTRO,
  ...DOCS_SECTIONS.flatMap((s) => s.items),
];

export function docsHref(path: string): string {
  return path ? `/docs/${path}` : '/docs';
}

export function findDocsItem(pathname: string): DocsNavItem | undefined {
  const cleaned = pathname.replace(/^\/docs\/?/, '').replace(/\/$/, '');
  if (!cleaned) return DOCS_INTRO;
  return DOCS_FLAT.find((item) => item.path === cleaned);
}

/** Resolve markdown-relative links (./foo.md, ../bar.md) to a docs path. */
export function resolveDocsMarkdownHref(href: string, currentPath: string): string | null {
  if (!href) return null;
  if (href.startsWith('http://') || href.startsWith('https://') || href.startsWith('mailto:')) {
    return null;
  }
  if (href.startsWith('#')) return href;

  let raw = href.split('#')[0];
  const hash = href.includes('#') ? `#${href.split('#').slice(1).join('#')}` : '';
  raw = raw.replace(/^\.\//, '');

  let baseDir = currentPath.includes('/') ? currentPath.replace(/\/[^/]+$/, '') : '';
  // From intro (empty path), relative "./spolecne/foo.md" is under root
  if (raw.startsWith('../')) {
    while (raw.startsWith('../')) {
      raw = raw.slice(3);
      baseDir = baseDir.includes('/') ? baseDir.replace(/\/[^/]+$/, '') : '';
    }
  }

  let joined = baseDir ? `${baseDir}/${raw}` : raw;
  joined = joined.replace(/\.md$/i, '').replace(/\/+/g, '/').replace(/\/$/, '');

  // Directory index links like "./spolecne/" → first item in section if exists
  if (joined && !joined.includes('/') && DOCS_SECTIONS.some((s) => s.id === joined)) {
    const section = DOCS_SECTIONS.find((s) => s.id === joined);
    if (section?.items[0]) return docsHref(section.items[0].path) + hash;
  }

  const match = DOCS_FLAT.find((item) => item.path === joined || item.file.replace(/\.md$/, '') === joined);
  if (match) return docsHref(match.path) + hash;

  // Fallback: treat as docs path
  return docsHref(joined) + hash;
}

export function getPrevNext(path: string): { prev?: DocsNavItem; next?: DocsNavItem } {
  const idx = DOCS_FLAT.findIndex((item) => item.path === path);
  if (idx < 0) return {};
  return {
    prev: idx > 0 ? DOCS_FLAT[idx - 1] : undefined,
    next: idx < DOCS_FLAT.length - 1 ? DOCS_FLAT[idx + 1] : undefined,
  };
}
